






// Incluimos los mensajes de este módulo
import i18nMessages from "@/i18n/app.messages";
import GlobalMixin from "@/mixins/global"

export default GlobalMixin.extend({
  i18n: i18nMessages,
  name: 'app',
  data(){
    return {
      moduleName: 'APP',
    }
  }
})
